import { useCallback } from "react";

import { useFeatures } from "components/FeatureFlag";

import useOnboardingContentPreference from "./useOnboardingContentPreference";

export function useOnboardingContentManager() {
  const { updateOnboardingContentPreference } =
    useOnboardingContentPreference();
  const { onboardingClickLimit } = useFeatures("onboarding-content");

  const shouldShowOnboardingContent = useCallback(
    (user, selectedHub) => {
      if (!selectedHub || selectedHub?.useCases?.visible) {
        return false;
      }

      if (!onboardingClickLimit || !user?.onboardingContent?.visible) {
        return false;
      }

      if (user?.snooze["onboarding-content"]) {
        return false;
      }

      const currentCount = user.onboardingContent?.clickCount ?? 0;

      return currentCount < onboardingClickLimit;
    },
    [onboardingClickLimit]
  );

  const updateHubClickCount = useCallback(
    (user, selectedHub) => {
      if (
        !user?.onboardingContent?.visible ||
        !shouldShowOnboardingContent(user, selectedHub)
      ) {
        return;
      }

      updateOnboardingContentPreference({ incrementClick: true });
    },
    [shouldShowOnboardingContent, updateOnboardingContentPreference]
  );

  return { shouldShowOnboardingContent, updateHubClickCount };
}

export default useOnboardingContentManager;
